import { render, staticRenderFns } from "./WorkGroupChange.vue?vue&type=template&id=3224094c&scoped=true&"
import script from "./WorkGroupChange.vue?vue&type=script&lang=js&"
export * from "./WorkGroupChange.vue?vue&type=script&lang=js&"
import style0 from "./WorkGroupChange.vue?vue&type=style&index=0&id=3224094c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3224094c",
  null
  
)

export default component.exports